import styled from 'styled-components';
import {
    Screen,
    screenFrom
} from '@client/styles/styled-components/breakpoints';
import { colorExtraLight } from '@client/styles/styled-components/variables';

export const OutterWrapper = styled.div`
    margin-bottom: 75px;
    ${screenFrom(Screen.mobile)} {
        margin-bottom: 90px;
    }
`;

export const Wrapper = styled.div`
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 400px;
    margin-top: 60px;

    ${screenFrom(Screen.mobile)} {
        height: 335px;
        margin-top: 75px;
    }
    ${screenFrom(Screen.desktop)} {
        height: 500px;
    }
`;

export const InnerWrapper = styled.div`
    max-width: 1500px;
    width: 100%;

    padding: 0;
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100%;

    ${screenFrom(Screen.mobile)} {
        padding: 0 3%;
    }

    ${screenFrom(Screen.desktop)} {
        width: 80%;
        padding: 0;
        margin: 0 auto 0;
    }
`;

interface TabsWrapperProps {
    readonly floating: boolean;
    readonly floatingHidden: boolean;
}

export const TabsWrapper = styled.div<TabsWrapperProps>`
    width: 100%;
    position: absolute;
    transition: top 0.15s linear;
    overflow: hidden;
    height: 50px;
    background-color: ${colorExtraLight};
    margin: 15px 0 10px;

    ${screenFrom(Screen.mobile)} {
        margin: 20px 0;
    }

    ${({ floating }) =>
        floating &&
        `
        position: fixed;
        z-index: 1000;
        box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
        top: 60px;
        margin-top: 0;
        ${screenFrom(Screen.mobile)} {
            margin-top: 0;
            top: 75px;
        }
    `}

    ${({ floatingHidden }) =>
        floatingHidden &&
        `
        top: 10px;
        box-shadow: none;
        ${screenFrom(Screen.mobile)} {
            top: 25px;
        }
    `}
`;

export const SpinnerWrapper = styled.div`
    width: 100%;
    margin: 60px auto 30px;
    display: flex;
    justify-content: center;

    ${screenFrom(Screen.mobile)} {
        margin-top: 75px;
    }

`;
